import { render, staticRenderFns } from "./edit-dialog-sender-update.vue?vue&type=template&id=4292db91&"
import script from "./edit-dialog-sender-update.vue?vue&type=script&lang=js&"
export * from "./edit-dialog-sender-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports